export default {
  updateActiveReport(state, report) {
    state.activeReport = report
  },

  updateActiveFilters(state, filters) {
    state.activeFilters = filters
  },

  updateActiveControls(state, controls) {
    state.activeControls = { ...state.activeControls, ...controls }
  },
}
